(() => {
  // Hold only below-fold AReviews photos on mobile until the review section is near.
  const start = () => {
    if (
      !window.matchMedia('(max-width: 767px)').matches
      || !('IntersectionObserver' in window)
    ) {
      return;
    }

    const section = document.querySelector('#AreviewsContainer') || document.querySelector('#az_reviews');

    if (!section) {
      return;
    }

    const imageHost = 'images.areviewsapp.com';
    const placeholder = 'https://areviewsapp.com/public/images/white_imge.png';
    const originalSetAttribute = Element.prototype.setAttribute;
    const originalInnerHTMLDescriptor = Object.getOwnPropertyDescriptor(Element.prototype, 'innerHTML');
    const originalSrcDescriptor = Object.getOwnPropertyDescriptor(HTMLImageElement.prototype, 'src');
    let released = false;
    let sectionObserver = null;
    let sectionMutationObserver = null;

    const isReviewUrl = (value) => typeof value === 'string' && value.includes(imageHost);

    const isReviewImage = (image, value) => {
      if (!isReviewUrl(value)) {
        return false;
      }

      return image.classList.contains('areviewslazy')
        || Boolean(image.closest('#AreviewsContainer, #az_reviews'))
        || isReviewUrl(image.dataset.src)
        || isReviewUrl(image.dataset.timelessorReviewSrc);
    };

    const storeReviewSource = (image, value) => {
      originalSetAttribute.call(image, 'data-timelessor-review-src', value);
      originalSetAttribute.call(image, 'loading', 'lazy');
      originalSetAttribute.call(image, 'decoding', 'async');
      originalSetAttribute.call(image, 'fetchpriority', 'low');
    };

    const holdReviewSource = (image, value, writeSource) => {
      if (released || !isReviewImage(image, value)) {
        return false;
      }

      storeReviewSource(image, value);
      writeSource(placeholder);
      return true;
    };

    const guardedSetAttribute = function(name, value) {
      if (
        this instanceof HTMLImageElement
        && String(name).toLowerCase() === 'src'
        && holdReviewSource(this, String(value), (nextValue) => {
          originalSetAttribute.call(this, name, nextValue);
        })
      ) {
        return;
      }

      return originalSetAttribute.call(this, name, value);
    };

    const guardedSrcDescriptor = {
      configurable: originalSrcDescriptor.configurable,
      enumerable: originalSrcDescriptor.enumerable,
      get: originalSrcDescriptor.get,
      set(value) {
        if (holdReviewSource(this, String(value), (nextValue) => {
          originalSrcDescriptor.set.call(this, nextValue);
        })) {
          return;
        }

        originalSrcDescriptor.set.call(this, value);
      }
    };

    const rewriteReviewMarkup = (value) => {
      if (typeof value !== 'string' || !value.includes(imageHost)) {
        return value;
      }

      const template = document.createElement('template');
      originalInnerHTMLDescriptor.set.call(template, value);

      template.content.querySelectorAll('img').forEach((image) => {
        const imageUrl = image.getAttribute('src') || image.getAttribute('data-src') || '';

        if (!isReviewUrl(imageUrl)) {
          return;
        }

        storeReviewSource(image, imageUrl);
        originalSetAttribute.call(image, 'src', placeholder);
      });

      return originalInnerHTMLDescriptor.get.call(template);
    };

    const guardedInnerHTMLDescriptor = {
      configurable: originalInnerHTMLDescriptor.configurable,
      enumerable: originalInnerHTMLDescriptor.enumerable,
      get: originalInnerHTMLDescriptor.get,
      set(value) {
        originalInnerHTMLDescriptor.set.call(this, rewriteReviewMarkup(value));
      }
    };

    Element.prototype.setAttribute = guardedSetAttribute;
    Object.defineProperty(Element.prototype, 'innerHTML', guardedInnerHTMLDescriptor);
    Object.defineProperty(HTMLImageElement.prototype, 'src', guardedSrcDescriptor);

    const restoreImageBehavior = () => {
      if (Element.prototype.setAttribute === guardedSetAttribute) {
        Element.prototype.setAttribute = originalSetAttribute;
      }

      Object.defineProperty(Element.prototype, 'innerHTML', originalInnerHTMLDescriptor);
      Object.defineProperty(HTMLImageElement.prototype, 'src', originalSrcDescriptor);
    };

    const protectImage = (image) => {
      const currentUrl = image.getAttribute('src') || '';
      const reviewUrl = image.dataset.timelessorReviewSrc || image.dataset.src || currentUrl;

      if (!isReviewUrl(reviewUrl)) {
        return;
      }

      storeReviewSource(image, reviewUrl);

      if (currentUrl !== placeholder) {
        originalSetAttribute.call(image, 'src', placeholder);
      }
    };

    const protectNode = (node) => {
      if (node.nodeType !== Node.ELEMENT_NODE) {
        return;
      }

      if (node instanceof HTMLImageElement) {
        protectImage(node);
      }

      node.querySelectorAll('img').forEach(protectImage);
    };

    const releaseImages = () => {
      released = true;

      if (sectionMutationObserver) {
        sectionMutationObserver.disconnect();
      }

      if (sectionObserver) {
        sectionObserver.disconnect();
      }

      restoreImageBehavior();

      section.querySelectorAll('img[data-timelessor-review-src]').forEach((image) => {
        const imageUrl = image.dataset.timelessorReviewSrc;

        if (imageUrl) {
          originalSetAttribute.call(image, 'src', imageUrl);
        }
      });
    };

    sectionMutationObserver = new MutationObserver((mutations) => {
      if (released) {
        return;
      }

      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes') {
          protectImage(mutation.target);
          return;
        }

        mutation.addedNodes.forEach(protectNode);
      });
    });

    sectionMutationObserver.observe(section, {
      attributes: true,
      attributeFilter: ['src'],
      childList: true,
      subtree: true
    });

    section.querySelectorAll('img').forEach(protectImage);

    sectionObserver = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) {
        releaseImages();
      }
    }, {
      rootMargin: '1200px 0px'
    });

    window.setTimeout(() => {
      const rect = section.getBoundingClientRect();
      const isNearViewport = rect.top <= window.innerHeight + 1200 && rect.bottom >= -1200;

      if (isNearViewport) {
        releaseImages();
        return;
      }

      sectionObserver.observe(section);
    }, 500);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();

(() => {
  const start = () => {
    const selector = 'product-sticky-form[data-tl-mobile-sticky]';
    if (!document.querySelector(selector)) return;

    const mobile = window.matchMedia('(max-width: 999px)');
    const overlaySelector = 'cart-drawer[open], mobile-navigation[open], .drawer[open], .popover[open], product-image-zoom[open], product-image-zoom.pswp--open, dialog[open]';
    const checkoutSelector = '[data-tl-yampi-checkout][aria-busy="true"], .ymp_elem_mainBtn[aria-busy="true"]';
    let scheduled = false;

    const isEditing = (bar) => {
      const active = document.activeElement;
      if (!active || bar.contains(active)) return false;
      if (active.isContentEditable || /^(TEXTAREA|SELECT)$/.test(active.tagName)) return true;
      return active.tagName === 'INPUT' && !/^(button|submit|reset|checkbox|radio|range|color|file|hidden|image)$/i.test(active.type);
    };

    const viewportReduced = () => {
      const viewport = window.visualViewport;
      if (!viewport || viewport.scale > 1.05) return false;
      return window.innerHeight - viewport.height - viewport.offsetTop > Math.max(120, window.innerHeight * 0.2);
    };

    const sync = () => {
      scheduled = false;
      const bars = document.querySelectorAll(selector);
      const needsContext = mobile.matches
        && Array.from(bars).some((bar) => !bar.hasAttribute('hidden'));
      const contextBlocked = needsContext && Boolean(document.querySelector(overlaySelector)
        || document.querySelector(checkoutSelector)
        || document.documentElement.classList.contains('lock-all')
        || document.documentElement.classList.contains('lock-mobile')
        || viewportReduced());

      bars.forEach((bar) => {
        const blocked = !mobile.matches || bar.hasAttribute('hidden') || contextBlocked || isEditing(bar);
        if (bar.hasAttribute('data-tl-sticky-blocked') !== blocked) bar.toggleAttribute('data-tl-sticky-blocked', blocked);
        if (bar.hasAttribute('inert') !== blocked) bar.toggleAttribute('inert', blocked);
        if (blocked) {
          if (bar.getAttribute('aria-hidden') !== 'true') bar.setAttribute('aria-hidden', 'true');
        } else if (bar.hasAttribute('aria-hidden')) {
          bar.removeAttribute('aria-hidden');
        }
      });
    };

    const schedule = () => {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(sync);
    };

    new MutationObserver(schedule).observe(document.documentElement, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['open', 'class', 'hidden', 'aria-busy', 'aria-expanded']
    });

    document.addEventListener('focusin', sync);
    document.addEventListener('focusout', schedule);
    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('orientationchange', schedule, { passive: true });
    window.addEventListener('pageshow', schedule);
    if (mobile.addEventListener) mobile.addEventListener('change', schedule);
    else mobile.addListener(schedule);
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', schedule, { passive: true });
      window.visualViewport.addEventListener('scroll', schedule, { passive: true });
    }
    sync();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();

